<div class="wrapper" [ngClass]="{
		'selected': !!row?.selected, 'single-column' : (visibleColumns === 1),
		'dark-theme': theme === 'darkTheme', 'socials-theme': theme === 'socials-theme'}">

	<bb-table-cell [ngClass]="{'unused': !multiSelect}" [theme]="theme">
		<bb-check *ngIf="multiSelect" [checked]="row.selected" (onChanged)="checkboxChanged()"
			(click)="checkboxClicked($event)"></bb-check>
	</bb-table-cell>

	<ng-content select="bb-table-cell"></ng-content>
	<ng-content select="ng-container"></ng-content>
</div>
<div class="wrapper" [ngClass]="{
		'selected': !!row?.selected, 'single-column' : (visibleColumns === 1),
		'dark-theme': theme === 'darkTheme', 'socials-theme': theme === 'socials-theme'}">
	<ng-content select="bb-table-container"></ng-content>
</div>

<div class="quick-edit-wrapper" *ngIf="row && row?.quickEditing">
	<td class="quick-edit-cell" [attr.colspan]="colspan" [style.height]="row?.quickEditing ? 'auto' : '0'">
		<ng-content select="[quickedit]"></ng-content>
	</td>
</div>
